import { select, put, all } from 'redux-saga/effects'
import { getSelf } from '@modules/auth/auth.Dux'
import { combineReducers } from 'redux'
import Consultations from '@services/Consultations'
import { PAAS_ADMIN, PROVIDER_ADMIN, SUPER_ADMIN } from '@constants/adminRoles'

//COMPANIES
const COMPANIES_FETCHED = 'COMPANIES_FETCHED'
export const companiesFetched = (companies) => ({
  type: COMPANIES_FETCHED,
  companies,
})

const initialCompanyState = []
const companyReducer = (state = initialCompanyState, action) => {
  switch (action.type) {
    case COMPANIES_FETCHED:
      return action.companies.sort((a, b) => (b.name < a.name ? 1 : -1))
    default:
      return state
  }
}

export const selectCompanies = (state) => state.admin.companies

//PROVIDERS
const initialProviderState = []
const providerReducer = (state = initialProviderState, action) => {
  switch (action.type) {
    case PROVIDERS_FETCHED:
      return action.providers.sort((a, b) => (b.name < a.name ? 1 : -1))
    default:
      return state
  }
}

const PROVIDERS_FETCHED = 'PROVIDERS_FETCHED'
export const providersFetched = (providers) => ({
  type: PROVIDERS_FETCHED,
  providers,
})

export const selectProviders = (state) => state.admin.providers

//ROLES
const initialRoleState = []
const roleReducer = (state = initialRoleState, action) => {
  switch (action.type) {
    case ROLES_FETCHED:
      return action.roles.sort((a, b) => (b.name < a.name ? 1 : -1))
    default:
      return state
  }
}

const ROLES_FETCHED = 'ROLES_FETCHED'
export const rolesFetched = (roles) => ({
  type: ROLES_FETCHED,
  roles,
})

export const selectRoles = (state) => state.admin.roles

//APP_ROLES
const initialAppRoleState = []
const appRoleReducer = (state = initialAppRoleState, action) => {
  switch (action.type) {
    case APP_ROLES_FETCHED:
      return action.appRoles.sort((a, b) => (b.name < a.name ? 1 : -1))
    default:
      return state
  }
}

const APP_ROLES_FETCHED = 'APP_ROLES_FETCHED'
export const appRolesFetched = (appRoles) => ({
  type: APP_ROLES_FETCHED,
  appRoles,
})

export const selectAppRoles = (state) => state.admin.appRoles

//COUNTRIES
const initialCountryState = []
const countryReducer = (state = initialCountryState, action) => {
  switch (action.type) {
    case COUNTRIES_FETCHED:
      return action.countries.sort((a, b) => (b.name < a.name ? 1 : -1))
    default:
      return state
  }
}

const COUNTRIES_FETCHED = 'COUNTRIES_FETCHED'
export const countriesFetched = (countries) => ({
  type: COUNTRIES_FETCHED,
  countries,
})

export const selectCountries = (state) => state.admin.countries

//LANGUAGES
const initialLanguageState = []
const languageReducer = (state = initialLanguageState, action) => {
  switch (action.type) {
    case LANGUAGES_FETCHED:
      return action.languages.sort((a, b) => (b.name < a.name ? 1 : -1))
    default:
      return state
  }
}

const LANGUAGES_FETCHED = 'LANGUAGES_FETCHED'
export const languagesFetched = (languages) => ({
  type: LANGUAGES_FETCHED,
  languages,
})

export const selectLanguages = (state) => state.admin.languages

//ADMIN_REDUCER
export const adminReducer = combineReducers({
  companies: companyReducer,
  providers: providerReducer,
  roles: roleReducer,
  appRoles: appRoleReducer,
  countries: countryReducer,
  languages: languageReducer,
})

export const REFRESH_ADMIN_DATA_TRIGGER = 'REFRESH_ADMIN_DATA_TRIGGER'
export const refreshAdminDataTrigger = () => ({
  type: REFRESH_ADMIN_DATA_TRIGGER,
})

export function* refreshAdminDataMiddleware() {
  try {
    const self = yield select(getSelf)

    if (!self.isAdmin) return null

    //TODO: we force to make a single call first because issues if many parallel calls execute a token refresh
    if (self.profile.type === SUPER_ADMIN || self.profile.type === PAAS_ADMIN || self.profile.type === PROVIDER_ADMIN) {
      const rolesResponse = yield Consultations.role.index()
      yield put(rolesFetched(rolesResponse.data))

      const appRolesResponse = yield Consultations.appRole.index()
      yield put(appRolesFetched(appRolesResponse.data))
    }

    //TODO.READ: https://redux-saga.js.org/docs/advanced/RunningTasksInParallel.html
    const [countriesResponse, languagesResponse] = yield all([
      Consultations.country.index(),
      Consultations.language.index(),
    ])

    yield put(countriesFetched(countriesResponse.data))
    yield put(languagesFetched(languagesResponse.data))

    if (self.isSuperAdmin) {
      const [companiesResponse, providersResponse] = yield all([
        Consultations.companyNew.index(),
        Consultations.provider.index(),
      ])
      yield put(companiesFetched(companiesResponse.data))
      yield put(providersFetched(providersResponse.data))
    }
  } catch (e) {
    window.alert(JSON.stringify(e.message, null, 2))
    console.error(e)
  }
}
